import React from 'react';

class ButtonMore extends React.Component{
    render(){
        return <a href={this.props.href} className="btn btn-outline-secondary"> <i className="fas fa-plus-circle"></i> Ver Más</a>
    }
}

export default ButtonMore;